<template>
  <v-container fluid class="d-flex justify-center align-center flex-column" :style="`margin-left: ${margin}`">
    <div class="report-wrapper">
      <!-- Sticky Header with Filters -->
      <div class="table-header-filters">
        <v-row dense class="align-center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu v-model="reportFromMenu" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="filter-select"
                  :value="formatDateFrom"
                  label="Od datuma"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title scrollable @input="reportFromMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu v-model="reportToMenu" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="filter-select"
                  :value="formatDateTo"
                  label="Do datuma"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title scrollable @input="reportToMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete
              class="filter-select"
              dense
              outlined
              hide-details
              label="Prodajno mjesto"
              v-model="location"
              :items="locations"
              item-text="name"
              item-value="id"
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              class="filter-select"
              outlined
              clearable
              dense
              hide-details
              no-filter
              label="Pretraži artikl"
              :items="searchResults"
              :loading="searchLoading"
              :search-input.sync="itemSearchText"
              item-text="name"
              item-value="id"
              return-object
              v-model="selectedItem"
              @click:clear="resetPagination"
            ></v-autocomplete>
          </v-col>

          <!-- Action Cluster -->
          <v-col cols="auto" class="ml-auto d-flex align-center" style="gap: 8px">
            <v-btn :disabled="locationNotSelected || !selectedItem" class="search-btn" @click="searchFetch()" small>
              <v-icon small class="mr-1">mdi-magnify</v-icon>
              Pretraži
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :to="to" class="close-btn" v-bind="attrs" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Zatvori izvještaj</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <!-- Glass Table Wrapper -->
      <div class="glass-table-wrapper">
        <div id="table_info" justify="center" style="max-width: 1200px; min-width: 1200px; font-size: 16px; font-family: 'Roboto-Regular';">
        <!-- HTML Code: Place this code in the document's body (between the 'body' tags) where the table should appear -->
        <table id="firma"
          style="display: none; font-family: 'Roboto-Regular'">
          <tbody>
            <tr>
              <td>
                {{ company ? $options.filters.capitalize(company.name) : "" }}
              </td>
            </tr>
            <tr>
              <td>{{ company ? company.address + " " + company.city : "" }}</td>
            </tr>
            <tr>
              <td>OIB: {{ company ? company.oib : "" }}</td>
            </tr>
            <tr>
              <td>Prodajno mjesto: {{ location ? location.name : "" }}</td>
            </tr>
          </tbody>
        </table>
        <!-- Codes by Quackit.com -->

        <!--  -->
        <div style="font-family: font-family: Raleway, sans-serif;">
          <table justify="center"
            style="width: 100% !important; border: 0 !important"
            cellspacing="0"
            id="title">
            <thead>
              <tr class="pb-0 mb-0">
                <th colspan="6"
                  class="pb-0 mb-0">
                  <p class="gradient-text" style="font-weight: bold; font-size: 25px">
                    Skladišna kartica
                  </p>
                </th>
              </tr>
              <tr class="pa-0 ma-0">
                <th colspan="6">
                  <p style="font-weight: bold; font-size: 12px">
                    za razdoblje od {{ formatDateFrom }} do
                    {{ formatDateTo }}
                  </p>
                </th>
              </tr>
            </thead>
          </table>
          <v-container class="d-flex justify-center align-center">
            <v-row style="min-width: 50% !important; max-width: 50% !important;"
              justify="center"
              align="center">
              <v-tabs v-if="selectedItem"
                v-model="activeTab"
                class="w-100"
                justify="space-around"
                style="width: 100%"
                @change="onTabChange">
                <v-tab class="flex-grow-1 text-center">Primke</v-tab>
                <v-tab class="flex-grow-1 text-center">Otpremnice</v-tab>
              </v-tabs>
            </v-row>
          </v-container>
          <v-tabs-items v-if="(primke && primke.length > 0) || (otpremnice && otpremnice.length > 0)"
            v-model="activeTab">
            <v-tab-item>
              <v-card>
                <v-card-text>

                  <v-data-table :fixed-header="true"
                    :headers="primkeHeaders"
                    :items="primke"
                    :show-header="false"
                    :items-per-page="-1"
                    :disable-pagination="true"
                    class="elevation-1 fixed-height-table"
                    :hide-default-footer="true"
                    height="55vh">
                    <template #top>
                      <div class="d-flex justify-space-between align-center pa-3">
                        <span class="text-h6">Primke</span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                <v-btn class="mb-3 mr-2"
                                  style="min-width: 44px !important"
                                  height="2.5rem"
                                  v-bind="tooltipAttrs"
                                  v-on="Object.assign({}, on, tooltipOn)">
                                  <v-icon>mdi-download</v-icon>
                                </v-btn>
                              </template>
                              <span>Preuzmi</span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item @click="downloadPrimkePdf()">
                              <v-list-item-title>Preuzmi PDF</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportPrimkeToExcel()">
                              <v-list-item-title>Preuzmi Excel</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                    <template #[`item.price`]="{ item }">
                      {{ (item.price / 100).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €' }}
                    </template>

                    <template #[`item.receivedPrice`]="{ item }">
                      {{ (item.receivedPrice / 100).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €' }}
                    </template>

                    <template #[`item.quantity`]="{ item }">
                      {{ (item.quantity / 1000).toLocaleString('hr-HR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}
                    </template>

                    <template #[`item.receivedQuantity`]="{ item }">
                      {{ (item.receivedQuantity / 1000).toLocaleString('hr-HR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}
                    </template>

                    <template #footer>
                      <div class="footer-wrapper">

                        <div class="text-center pt-2 pb-2"
                          v-if="hasMoreItems">

                          <v-btn class="white--text okButton font-weight-bold rounded-card"
                            style="font-size: 12px"
                            width="20%"
                            color="loginButton"
                            height="45"
                            x-large
                            id="registerBtn"
                            @click="loadMore('deliveryNotes')">
                            Učitaj još...
                          </v-btn>
                        </div>
                      </div>

                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-data-table :fixed-header="true"
                    :headers="otpremniceHeaders"
                    :items="otpremnice"
                    :items-per-page="10"
                    :disable-pagination="true"
                    class="elevation-1 fixed-height-table"
                    :hide-default-footer="true"
                    height="55vh">
                    <template #top>
                      <div class="d-flex justify-space-between align-center pa-3">
                        <span class="text-h6">Otpremnice</span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                <v-btn class="mb-3 mr-2"
                                  style="min-width: 44px !important"
                                  height="2.5rem"
                                  v-bind="tooltipAttrs"
                                  v-on="Object.assign({}, on, tooltipOn)">
                                  <v-icon>mdi-download</v-icon>
                                </v-btn>
                              </template>
                              <span>Preuzmi</span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item @click="downloadOtpremnicePdf()">
                              <v-list-item-title>Preuzmi PDF</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportOtpremniceToExcel()">
                              <v-list-item-title>Preuzmi Excel</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                    <template #[`item.price`]="{ item }">
                      {{ (item.price / 100).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €' }}
                    </template>

                    <template #[`item.quantity`]="{ item }">
                      {{ (item.quantity / 1000).toLocaleString('hr-HR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}
                    </template>

                    <template #footer>
                      <div class="text-center pt-2 pb-2"
                        v-if="hasMoreItems">
                        <v-btn class="white--text okButton font-weight-bold rounded-card"
                          style="font-size: 12px"
                          width="20%"
                          color="loginButton"
                          height="45"
                          x-large
                          id="registerBtn"
                          @click="loadMore('shipmentNotes')">
                          Učitaj još...
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </div>
        <!-- <div justify="center">
          <table justify="center"
            style="width: 100% !important; table-layout: fixed;"
            border="1"
            cellspacing="0"
            bordercolor="#cacccb"
            id="tableTraffic"
            class="tableTraffic"
            v-if="showTableData">
            <colgroup>
              <col style="width: 20%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
            </colgroup>
            <tbody style="min-width: 100% !important">
              <tr style="text-align: left; font-weight: bold; background-color: #dcdcdc; min-width: 100% !important;">
                <td style="text-align: center;">Artikl</td>
                <td style="text-align: center;">Cijena</td>
                <td style="text-align: center;">Ulaz</td>
                <td style="text-align: center;">Vrijednost</td>
                <td style="text-align: center;">Izlaz</td>
                <td style="text-align: center;">Vrijednost</td>
                <td colspan="2"
                  style="text-align: center">Zaliha</td>
                <td style="text-align: center;">Vrijednost</td>

              </tr>
            </tbody>
          </table>
        </div> -->
        </div>
      </div>
      <!-- End Glass Table Wrapper -->
    </div>
    <!-- End Report Wrapper -->
  </v-container>
</template>
<script>

import { DAY, clone } from '@/plugins/utils'
import { df, auth } from '@/plugins/firebase'
import state from '@/state'
import triGram from '@/mixins/trigram'
import 'jspdf-autotable'
import { saveExcel } from '@/modules/all-reports/xlsx/config.js'
import EventBus from '@/plugins/event-bus'
import { initPdf, setTable, setPageNumber } from '@/modules/all-reports/pdf/config.js'
import { getReport } from '@/api/report'
import * as XLSX from 'xlsx'
import { jsPDF } from 'jspdf'

export default {
  name: 'Reports',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  mixins: [triGram],
  components: {},
  data: function () {
    return {
      dateFrom: new Date(new Date().getTime() - DAY)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      location: null,
      locations: [],
      warehouse: null,
      reportFromMenu: undefined,
      reportToMenu: undefined,
      company: undefined,
      currency: 'EUR',
      selectedItem: undefined,
      searchResults: [],
      searchLoading: false,
      itemSearchText: '',
      tableWidth: '1200px',
      a4PortraitWidth: '575px',
      a4LandscapeWidth: '610px',
      targetModifier: '',
      viewType: 'pdf',
      showTableData: false,
      activeTab: 0,
      primkeHeaders: [
        { text: 'Datum', value: 'deliveryDate' },
        { text: 'Broj primke', value: 'deliveryNumber' },
        { text: 'Osnovna cijena', value: 'price' },
        { text: 'Osnovna količina', value: 'quantity' },
        { text: 'Osnovna mj. jedinica', value: 'unit' },
        { text: 'Zaprimljena cijena', value: 'receivedPrice' },
        { text: 'Zaprimljena količina', value: 'receivedQuantity' },
        { text: 'Zaprimljena mj. jedinica', value: 'receivedUnit' }
      ],
      primke: [],
      otpremniceHeaders: [
        { text: 'Datum', value: 'created' },
        { text: 'Broj računa', value: 'receiptNumber' },
        { text: 'Količina', value: 'quantity' },
        { text: 'Mj. jedinica', value: 'unit' }
      ],
      otpremnice: [],
      hasMoreItems: true
    }
  },
  computed: {
    to () {
      return { name: `${this.targetModifier}.all-reports.reportMenu` }
    },
    formatDateTo () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateTo))
    },
    formatDateFrom () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateFrom))
    },
    locationNotSelected () {
      return !this.location || !this.location.id
    }
  },
  async created () {
    this.margin = state.getMargin()
    await this.getPointsOfSale()
  },
  mounted () {
    var sideNav = this.$route.meta.sideNav
    switch (sideNav) {
      case 'Companies':
        break
      case 'Company':
        this.targetModifier = 'company'
        break
      case 'PointOfSale':
        this.targetModifier = 'pointOfSale'
        break
      case 'CashRegister':
        this.targetModifier = 'pointOfSale'
        break
    }

    EventBus.$on('set-mini', () => {
      this.margin = state.getMargin()
    })

    this.company = clone(state.getCurrentCompany())
    this.location = clone(state.getPointOfSale())
  },
  watch: {
    itemSearchText (val) {
      if (!val || val.length < 2) return
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => this.searchItems(val), 300)
    }
  },

  methods: {
    exportOtpremniceToExcel () {
      this.showLoader()
      const headers = this.otpremniceHeaders.map(header => this.sanitizeHeader(header.text))

      const data = this.otpremnice.map(item => {
        return this.otpremniceHeaders.map(header => {
          const value = item[header.value]

          if (header.value === 'price') {
            return (value / 100).toFixed(2).replace(',', '.') + ' €'
          }
          if (header.value === 'quantity') {
            return (value / 1000).toFixed(4).replace(',', '.')
          }
          return value
        })
      })

      const title = [`Popis otpremnica - ${this.selectedItem.name}`]
      const dateRange = [`Razdoblje: ${this.formatDateFrom} - ${this.formatDateTo}`]
      const emptyRow = []

      const worksheetData = [title, dateRange, emptyRow, headers, ...data]
      const ws = XLSX.utils.aoa_to_sheet(worksheetData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Otpremnice')
      XLSX.writeFile(wb, `${this.selectedItem.name}_otpremnice.xlsx`)
      this.hideLoader()
    },
    downloadOtpremnicePdf () {
      // eslint-disable-next-line new-cap
      const doc = new jsPDF()
      doc.setFontSize(16)
      doc.text(`Popis otpremnica - ${this.selectedItem.name}`, 14, 15)
      doc.setFontSize(12)
      doc.text(`Razdoblje: ${this.formatDateFrom} - ${this.formatDateTo}`, 14, 25)

      const headers = this.otpremniceHeaders.map(header => this.sanitizeHeader(header.text))
      const data = this.otpremnice.map(item =>
        this.otpremniceHeaders.map(header => {
          const value = item[header.value]

          if (header.value === 'price') {
            return (value / 100).toFixed(2).replace(',', '.') + ' €'
          }
          if (header.value === 'quantity') {
            return (value / 1000).toFixed(4).replace(',', '.')
          }
          return value
        })
      )

      doc.autoTable({
        startY: 35,
        head: [headers],
        body: data,
        styles: { fontSize: 10 },
        theme: 'striped'
      })

      doc.save(`${this.selectedItem.name}_otpremnice.pdf`)
    },
    exportPrimkeToExcel () {
      this.showLoader()
      // 1. Postavi zaglavlja koristeći primkeHeaders
      const headers = this.primkeHeaders.map(header => header.text)

      // 2. Mapiraj podatke u odgovarajući format
      const data = this.primke.map(item => {
        return this.primkeHeaders.map(header => {
          const value = item[header.value]

          // Specijalno formatiranje za određene vrijednosti
          if (header.value === 'price' || header.value === 'receivedPrice') {
            return (value / 100).toFixed(2).replace(',', '.') + ' €'
          }
          if (header.value === 'quantity' || header.value === 'receivedQuantity') {
            return (value / 1000).toFixed(4).replace(',', '.')
          }

          return value
        })
      })

      const title = [`Popis primki - ${this.selectedItem.name}`]
      const dateRange = [`Razdoblje: ${this.formatDateFrom} - ${this.formatDateTo}`]
      const emptyRow = []

      // 3. Spoji zaglavlja i podatke u ispravnu strukturu
      const worksheetData = [title, dateRange, emptyRow, headers, ...data]

      // 4. Kreiranje radnog lista i dodavanje podataka
      const ws = XLSX.utils.aoa_to_sheet(worksheetData)

      // 5. Kreiranje radne knjige i dodavanje radnog lista
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Primke')

      // 6. Spremanje u Excel datoteku
      XLSX.writeFile(wb, `${this.selectedItem.name}_primke.xlsx`)

      this.hideLoader()
    },
    downloadPrimkePdf () {
      // eslint-disable-next-line new-cap
      const doc = new jsPDF()

      // Dodaj naslov
      doc.setFontSize(16)
      doc.text(`Popis primki - ${this.selectedItem.name}`, 14, 15)
      doc.setFontSize(12)
      doc.text(`Razdoblje: ${this.formatDateFrom} - ${this.formatDateTo}`, 14, 25)

      // Priprema podataka za tablicu
      const headers = this.primkeHeaders.map(header => this.sanitizeHeader(header.text))
      const data = this.primke.map(item =>
        this.primkeHeaders.map(header => {
          const value = item[header.value]

          if (header.value === 'price' || header.value === 'receivedPrice') {
            return (value / 100).toFixed(2).replace(',', '.') + ' €'
          }
          if (header.value === 'quantity' || header.value === 'receivedQuantity') {
            return (value / 1000).toFixed(4).replace(',', '.')
          }
          return value
        })
      )

      // Generiranje PDF tablice pomoću autoTable
      doc.autoTable({
        startY: 35,
        head: [headers],
        body: data,
        styles: { fontSize: 10 },
        theme: 'striped'
      })

      // Preuzmi PDF
      doc.save(`${this.selectedItem.name}_primke.pdf`)
    },
    sanitizeHeader (header) {
      return header.replace('č', 'c').replace('Č', 'C') // Zamjena č -> c, Č -> C
    },
    searchFetch () {
      if (this.activeTab === 0) {
        this.resetPagination()
        this.fetch('deliveryNotes')
      } else if (this.activeTab === 1) {
        this.resetPagination()
        this.fetch('shipmentNotes')
      }
    },
    onTabChange (newTab) {
      this.showLoader()
      if (newTab === 0) {
        this.resetPagination()
        this.fetch('deliveryNotes')
      } else if (newTab === 1) {
        this.resetPagination()
        this.fetch('shipmentNotes')
      }
    },
    async loadMore (type) {
      await this.fetch(type, true)
    },

    async fetch (type, loadMore = false) {
      this.showLoader()

      try {
        const dateFrom = new Date(this.dateFrom).getTime() / 1000
        var dateTo = new Date(this.dateTo)
        dateTo.setHours(23, 59, 59, 999)
        dateTo = dateTo.getTime() / 1000

        const query = df.collection('warehouses')
          .where('location_id', '==', this.location.id)
          .where('selling_warehouse', '==', true)

        const documentSnapshots = await query.get()

        if (!documentSnapshots.docs?.length) {
          throw new Error('Warehouse not found')
        }

        this.warehouse = documentSnapshots.docs[0].data()

        const payload = {
          dateFrom,
          dateTo,
          report: type,
          warehouseId: this.warehouse.id,
          item: this.selectedItem.id
        }

        if (this.lastDocumentedID) {
          payload.lastDocumentedID = this.lastDocumentedID
        }

        const response = await getReport(payload)

        if (response.status === 200) {
          var newItems = []

          switch (type) {
            case 'deliveryNotes':
              newItems = response.data.data.deliveryNotes

              this.hasMoreItems = newItems.length === 10

              if (loadMore) {
                this.primke.push(...newItems)
              } else {
                this.primke = newItems
              }
              break
            case 'shipmentNotes':
              newItems = response.data.data.shipmentNotes

              this.hasMoreItems = newItems.length === 10

              if (loadMore) {
                this.otpremnice.push(...newItems)
              } else {
                this.otpremnice = newItems
              }
              break
          }

          this.hideLoader()

          this.lastDocumentedID = response.data.data.lastDocumentId

          this.showTableData = false
          this.showItemsData = true
        } else {
          this.hideLoader()
          throw new Error(response.data.data.message)
        }
      } catch (error) {
        this.showMsgBox({
          text: error.message,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.hideLoader()
      } finally {
        this.hideLoader()
      }
    },

    resetPagination () {
      this.lastDocumentedID = ''
      this.hasMoreItems = true
      this.primke = []
      this.otpremnice = []
    },

    async searchItems (searchTerm) {
      this.searchLoading = true
      try {
        const trigramMap = this.triGram(searchTerm)
        let q = df.collection(`companies/${state.getCurrentCompany().id}/items`)
          .where('status', '==', 'OK')
        Object.keys(trigramMap).forEach(key => {
          q = q.where(`meta.${key}`, '==', true)
        })
        const snapshot = await q.limit(15).get()
        this.searchResults = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(item => !item.has_norm)
          .sort((a, b) => a.name.localeCompare(b.name))
      } catch (e) {
        console.error('Item search failed:', e)
      } finally {
        this.searchLoading = false
      }
    },

    changeWidth () {
      this.showLoader('', { opacity: 1 })
      document.getElementById('table_info').style.maxWidth = this.a4PortraitWidth
      document.getElementById('table_info').style.minWidth = this.a4PortraitWidth
      document.getElementById('table_info').style.fontSize = '80%'

      this.generatePdf()
    },
    async generatePdf () {
      const that = this
      const tableInfo = document.getElementById('table_info')
      try {
        // eslint-disable-next-line new-cap
        var doc = await initPdf()

        doc = await setTable(doc, '#firma', 10)
        var finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#title', finalY)
        finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#tableTraffic', finalY)

        doc = await setPageNumber(doc)

        doc.save('Rekapitulacija robno materijalnih kartica.pdf')
      } catch (error) {
        console.error('PDF generation error:', error)
      } finally {
        tableInfo.style.maxWidth = that.tableWidth
        tableInfo.style.minWidth = that.tableWidth
        tableInfo.style.fontSize = '100%'
        this.viewType = 'pdf'
        that.hideLoader()
      }
    },
    generateExcel () {
      this.showLoader('', { opacity: 1 })
      this.viewType = 'excel'
      setTimeout(() => {
        var tables = ['firma', 'title', 'tableTraffic']
        var fileName = 'Rekapitulacija robno materijalnih kartica.xlsx'

        saveExcel(tables, fileName)

        this.viewType = 'pdf'
        this.hideLoader()
      }, 1000)
    },
    async getPointsOfSale () {
      const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
      docRef.onSnapshot(doc => {
        var locations = Object.values(doc.data().locations)
        locations.forEach((location, index) => {
          this.locations.push(location)
        })
        // Sort locations alphabetically
        this.locations.sort((a, b) => a.name.localeCompare(b.name))
      })
      // const all = { name: 'Sva', id: 'all' }
      // this.locations.push(all)
      // this.location = all
    }
  }
}
</script>
<style scoped>
/* Report Wrapper */
.report-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Sticky Filter Header */
.table-header-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}

.table-header-filters >>> .v-row {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.table-header-filters >>> .v-row:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

.close-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(229, 57, 53, 0.2) !important;
  color: #e53935 !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.close-btn:hover {
  background: rgba(229, 57, 53, 0.07) !important;
  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.1) !important;
}

.search-btn {
  height: 36px !important;
  padding: 0 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.search-btn:hover:not(:disabled) {
  border-color: #3989C9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
}

.search-btn:disabled {
  opacity: 0.45 !important;
}

/* Glass Table Wrapper */
.glass-table-wrapper {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 30px;
  overflow-x: auto;
}

/* Gradient Text */
.gradient-text {
  color: #2d3748;
  -webkit-text-fill-color: #2d3748;
}

/* Table Styling */
.tableTraffic {
  border-collapse: collapse;
}

.blank_row {
  height: 25px !important;
  background-color: #ffffff;
  border: 0px red;
  border: none !important;
}

.glass-table-wrapper table { border-collapse: collapse; width: 100%; border: none; }
.glass-table-wrapper table th, .glass-table-wrapper table td { padding: 14px 20px; border: none; border-bottom: 1px solid #EDF2F7; font-variant-numeric: tabular-nums; }
.glass-table-wrapper table tbody tr:hover:not(.naslov):not(.row-total) { background: #F7FAFC; }

.naslov { background: #F8FAFC !important; font-weight: 700 !important; font-size: 13px !important; text-transform: uppercase !important; letter-spacing: 1px !important; color: #2D3748 !important; }
.naslov th, .naslov td { color: #2D3748 !important; font-weight: 700 !important; }
.row-total { background: rgba(0, 188, 212, 0.03) !important; font-weight: 700 !important; border-top: 2px solid rgba(0, 188, 212, 0.2) !important; color: #00838F !important; }
.row-total td, .row-total th { color: #00838F !important; font-weight: 700 !important; border-bottom: 2px solid rgba(0, 188, 212, 0.2) !important; }

.report-content-wrapper { margin-top: 40px; }

/* Tabs Styling */
.v-tabs {
  .v-tab {
    background-color: #fafafa;
  }

  .v-tab--selected {
    background-color: #c0c0c0;
  }
}

.footer-wrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
